import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'

export const getItemValue = (item: IJBPPlanningItem, fieldProps: IFieldProps): number => {
  let result = 0

  if (item) {
    const fieldName = getFieldName(fieldProps)
    result = item[fieldName]
  }

  return result
}
